export default {
  NETWORK_EMPTY: 0,
  //未初始化
  NETWORK_IDLE: 1,
  //未使用网络 304 缓存
  NETWORK_LOADING: 2,
  //浏览器正在下载数据
  NETWORK_NO_SOURCE: 3,
  //未找到资源
  NETWORK_READY_SUCCESS_STATE: 4 //成功

};